<template>
  <div class="slider-component">
    <div class="slider-wrapper">
      <div ref="slider"></div>
    </div>
  </div>
</template>

<script>
import noUiSlider from 'nouislider';
import 'nouislider/dist/nouislider.css';

export default {
  data() {
    return {
      lowerValue: 20,
      upperValue: 50,
    };
  },
  mounted() {
    this.initSlider();
  },
  methods: {
    initSlider() {
      const sliderElement = this.$refs.slider;

      noUiSlider.create(sliderElement, {
        start: [this.lowerValue, this.upperValue],
        connect: true,
        range: {
          min: 10,
          max: 65
        },
        step: 1,
        tooltips: true,
        format: {
          to: function (value) {
            return Math.round(value) + ' Zoll';
          },
          from: function (value) {
            return Math.round(Number(value.replace(' Zoll', '')));
          }
        }
      });
      sliderElement.noUiSlider.on('update', (values) => {
        const lowerValue = Number(values[0].replace(' Zoll', ''));
        const upperValue = Number(values[1].replace(' Zoll', ''));


        this.lowerValue = lowerValue;
        this.upperValue = upperValue;
        this.$emit('update-slider', this.lowerValue, this.upperValue);
      });
    }
  }
}
</script>

<style>
.slider-component {
  width: 70%;
  margin: 0 auto;
  margin-bottom: 5%;
  margin-top: 5%;
}

.slider-wrapper {
  width: 100%;
}

.noUi-handle {
  background-color: #E7EFFB;
}

.noUi-connect {
  background-color: #6CB5F5;
}
</style>
